import styled from "styled-components";
import { colors } from "assets";

export default c => styled(c)`
  .actions-label {
    font-weight: bold;
    color: #222222;
    margin-top: 12px;
    display: block;
    min-width: 450px;
  }

  .checkbox-color {
    color: ${colors.checkbox.normal};
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/webhooks/style.js